"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BlockchainsArray=exports.Blockchains=void 0;var Blockchains={EOS:"eos",ETH:"eth",TRX:"trx"};exports.Blockchains=Blockchains;var BlockchainsArray=Object.keys(Blockchains).map(function(a){return{key:a,value:Blockchains[a]}});exports.BlockchainsArray=BlockchainsArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@scatterjs/eosjs2/node_modules/@scatterjs/core/dist/models/Blockchains.js
// module id = tPHW
// module chunks = 1